<template>
  <!-- 首页的地图 -->
  <div>
    <div id="container" style=" { width: 566px; height: 330px; } "/>
  </div>
</template>

<script>
import AMap from "AMap"; // 引入高德地图AMap
import { mapState } from "vuex";
// import "@/assets/css/navigation.css";

export default {
  name: "HomeMap",
  props: {
    centerMapPoint: {
      type: Array,
      default() {
        return [100, 23];
      }
    },
  },
  data() {
    return {
      cycleTimer: null, // 循环计时器,更新地图图标位置
      timers: [], // 计时器们
    };
  },
  computed: {
    ...mapState({
      ambulanceLists: "ambulanceLists",
      allPosition: "allPosition"
    }),
    realAmbulanceList() {
      return this.ambulanceLists.filter(car => {
        return car.type === "急救车";
      });
    },
  },
  mounted() {
    this.map = null; // 高德地图map对象
    this.initMap();
  },
  beforeUnmount() {
    this.timers.forEach(e => {
      clearInterval(e);
      e = null;
    });
    this.map?.destroy();
    this.map = null;
    this.source?.close();
  },
  methods: {
    initMap() {
      let ambulanceIcon;
      // index页面的,显示hospital,医院本部地图
      //  先获得以下医院地址的经纬度
      this.map = new AMap.Map("container", {
        resizeEnable: true, // 是否监控地图容器尺寸变化
        zoom: 13, // 初始化地图层级
        center: [...this.centerMapPoint], // 初始化地图中心点
      });

      ambulanceIcon = new AMap.Icon({
        size: new AMap.Size(50, 32),
        image: require("@/assets/icons/hospital.png"),
        imageSize: new AMap.Size(32, 32),
      });

      const ambulanceMarker = new AMap.Marker({
        position: new AMap.LngLat(...this.centerMapPoint), // 急救车图标安排上
        icon: ambulanceIcon,
        offset: new AMap.Pixel(0, 0),
      });
      this.map.add(ambulanceMarker);

      // 遍历循环急救车列表, 拿到所有的急救车位置
      // 获得所有的急救车的地址
      this.realAmbulanceList.forEach(car => {
        ambulanceIcon = new AMap.Icon({
          size: new AMap.Size(50, 32),
          image: require("@/assets/photos/working.png"),
          imageSize: new AMap.Size(50, 32),
        });
        const { longitude, latitude } = car; // 首次拿到急救车的经纬度
        const ambulanceMarker = new AMap.Marker({
          position: new AMap.LngLat(longitude, latitude),
          icon: ambulanceIcon,
          offset: new AMap.Pixel(0, 0),
        });
        if (longitude && latitude) {
          this.map.add(ambulanceMarker);
        }
        const timer = setInterval(() => {
          if (this.allPosition[car.id]) {
            const long = this.allPosition[car.id]["longitude"];
            const lan = this.allPosition[car.id]["dimension"];
            if (long && lan) {
              ambulanceMarker.setPosition([long, lan]);
            }
          }
        }, 1000);
        this.timers.push(timer);
      });
    },
  },
};
</script>
